import styled from "styled-components";
import { spacing } from "../../../design-system/tokens/spacing";
import { rawColors } from "../../../design-system/tokens/colors";
import { borderRadius } from "../../../design-system/tokens/borders";

/**
 * Shared KG list page chrome — Figma "Home" (2306:12304).
 * Used by Reports, Metrics, Business Rules, Tribal Knowledge, etc.
 */
export const KgListShell = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  background-color: ${rawColors.structural.white};
  overflow: hidden;
  box-sizing: border-box;
`;

/** Filter tabs row — Figma Frame 2147223681 (2306:12305). */
export const KgListFilterHeader = styled.div`
  flex-shrink: 0;
  padding: ${spacing[3]};
  border-bottom: 1px solid ${rawColors.stroke[200]};
`;

/** Table body — Figma Frame 2147223680 (2306:12315). Pagination lives inside KgListTableFrame. */
export const KgListTableSection = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  padding: ${spacing[3]};
  background-color: ${rawColors.structural.themeLight};
  box-sizing: border-box;
  overflow: hidden;
`;

/** Bordered table frame (Figma Table 2306:12316). */
export const KgListTableFrame = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  background-color: ${rawColors.structural.white};
  border: 1px solid ${rawColors.stroke[200]};
  border-radius: ${borderRadius.lg};
  overflow: hidden;
`;

export const KgListScrollableBody = styled.div`
  flex: 1;
  min-height: 0;
  overflow: auto;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;
